<template>
  <div id="app">
    <mobileHome v-if="isMobile"></mobileHome>
    <webHome v-if="!isMobile"></webHome>
    <router-view></router-view>
  </div>
</template>
<script>
// @ is an alias to /src
import webHome from '@/components/webHome.vue'
import mobileHome from '@/components/mobileHome.vue'

export default {
  data: function () {
    return {
      isMobile: true
    }
  },
  components: {
    webHome,
    mobileHome
  },
  methods: {
    /* eslint-disable no-unused-vars */
    /* eslint-disable eqeqeq */
    browserRedirect: function () {
      var sUserAgent = navigator.userAgent.toLowerCase()
      var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
      var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
      var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
      var bIsAndroid = sUserAgent.match(/android/i) == 'android'
      var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
      var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
      if ((bIsIphoneOs || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) { // bIsIpad || bIsMidp ||
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  },
  created () {
    const that = this
    that.browserRedirect() // 检测设备类型
  },
  mounted () {
    document.onkeydown = function (e) {
      var currKey = 0
      var evt = e || window.event
      currKey = evt.KeyCode || evt.which || evt.charCode
      // var e = window.event || arguments[0];
      if (e.keyCode == 123) {
        window.event.cancelBubble = true
        window.event.returnValue = false
        return false
      }
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #f1f1f1;
}
</style>
